import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import useMergedState from "rc-util/es/hooks/useMergedState";

function useMountMergeState(initialState, option) {
  var _useMergedState = useMergedState(initialState, option),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      state = _useMergedState2[0],
      setState = _useMergedState2[1];

  return [state, setState];
}

export default useMountMergeState;